(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const faqItems = document.querySelectorAll('.faq-item');
  
  faqItems.forEach(function(item) {
    const question = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    
    question.addEventListener('click', function() {
      const isActive = item.classList.contains('active');
      
      // Optional: Close other items (uncomment next 3 lines for accordion behavior where only one item can be open)
      // faqItems.forEach(function(otherItem) {
      //   if (otherItem !== item) otherItem.classList.remove('active');
      // });
      
      // Toggle current item
      item.classList.toggle('active');
      
      // Update aria-expanded
      question.setAttribute('aria-expanded', !isActive);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
